import { Popover } from 'antd'
import React from 'react'
import Text from '../text'
import * as styles from './DealTag.css'

export const DealTag = ({ isAR, isZC }) => {
  const arContent = (
    <div>
      <p>AR deals will be automatically renewed at the end of deal maturity. (Subject to availability)</p>
    </div>
  )

  const zcContent = (
    <div>
      <p>We offer zero cost liquidity for this deal.</p>
    </div>
  )

  return (
    <div className={styles.tag}>
      {isAR && (
        <Popover content={arContent} title='Autorenew (AR)'>
          <div className={styles.outerAR}>
            <div className={styles.tagAR}>
              <Text bold size='0.8' color='white'>
                AR
              </Text>
            </div>
            <Text bold size='0.8' color='#35a37e'>
              Auto Renew
            </Text>
          </div>
        </Popover>
      )}
    </div>
  )
}
